import React, { useContext, useState } from "react";
import { IStep, PageContents, PreferredOption } from "./StrategyExercisePlan";
import { ProsAndConsList } from "./StepThree";
import { ThemeContext } from "styled-components";
import { StyledItemContainer, StyledSolutionCard, StyledSolutionCardsContainer, StyledSolutionHeading, StyledSolutionListItem } from "./StrategyExercisePlan.styled";
import { STEPS } from "models/exercises/IExercisePlan";

interface IStepFourProps extends IStep {
  solutions: string[];
  prosAndConsList: ProsAndConsList[];
  preferredOptionHandler: (option: PreferredOption) => void;
}


const ProsAndConsListComponent: React.FC<{ prosAndCons: ProsAndConsList }> = ({ prosAndCons }) => {
  const { pros, cons } = prosAndCons;
  return (
    <div>
      {pros.map((pro, index) => (
        <StyledItemContainer key={ `pro-${index}` }>
          <StyledSolutionListItem text={pro} isActive={false} ticked={true} />
        </StyledItemContainer>
      ))}
      {cons.map((con, index) => (
        <StyledItemContainer key={ `con-${index}` }>
          <StyledSolutionListItem text={con} isActive={true} />
        </StyledItemContainer>
      ))} 
    </div>
  )
}

export const StepFourPage: React.FC<IStepFourProps> = ({ content, setStep, solutions, prosAndConsList, preferredOptionHandler }) => {
  const themeContext = useContext(ThemeContext);
  const [selectedCard, setSelectedCard] = useState<number | null>(null);
  
  const onCtaClick = () => {
    if (selectedCard !== null) {
      preferredOptionHandler({ solution: solutions[selectedCard], prosAndCons: prosAndConsList[selectedCard] });
      setStep(STEPS.STEP_FIVE);
    }
  };

  const handleCardClick = (index: number) => () => {
    if (selectedCard === index) {
      setSelectedCard(null);
    } else {
      setSelectedCard(index);
    }
    
  }
  return (
    <PageContents content={content} onCtaClick={onCtaClick} isCtaButtonDisabled={selectedCard === null}>
      <StyledSolutionCardsContainer>
      {solutions.map((solution, index) => (
        <StyledSolutionCard
         headerContent={<StyledSolutionHeading>{solution}</StyledSolutionHeading>}
         key={`card-${index}`}
         headerColour={themeContext.colors.chooseCards[index % themeContext.colors.chooseCards.length]}
         bodyColour="#fff"
         bodyContent={<ProsAndConsListComponent prosAndCons={prosAndConsList[index]} />}
         onClick={handleCardClick(index)}
         $isSelected={selectedCard === index}
        />
      ))}
      </StyledSolutionCardsContainer>
    </PageContents>
  )
}